/**
 * useTempAccessWarning (KAN-204)
 *
 * Subscribes to the SSE event `TEMP_ACCESS_EXPIRING` and surfaces a
 * boolean flag so that App.tsx can show a dismissable warning banner
 * ~5 minutes before the user's temporary IP whitelist entry expires.
 */

import { useState, useCallback, useRef } from 'react';
import { useEventStreamSimple } from './useEventStreamSimple';

interface UseTempAccessWarningResult {
  showWarning: boolean;
  dismissWarning: () => void;
}

export function useTempAccessWarning(clientId: string): UseTempAccessWarningResult {
  const [showWarning, setShowWarning] = useState(false);
  const sessionStartRef = useRef(Date.now());

  const handleEvent = useCallback((eventData: any) => {
    if (eventData.type === 'TEMP_ACCESS_EXPIRING') {
      // Ignore events from before this session
      const eventTime = eventData.timestamp ? new Date(eventData.timestamp).getTime() : Infinity;
      if (eventTime < sessionStartRef.current) return;
      setShowWarning(true);
    }
  }, []);

  useEventStreamSimple({
    clientId,
    eventTypes: ['TEMP_ACCESS_EXPIRING'],
    onEvent: handleEvent,
  });

  const dismissWarning = useCallback(() => setShowWarning(false), []);

  return { showWarning, dismissWarning };
}
